import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TranslationState } from "../objects/translationState";
import { Translation, TranslationRow } from "../objects/translation";
import { EMPTY_TRANSLATION_FILTER } from "../constants/translationConstants";
import { TranslationFilterCriteria } from "../objects/translationFilterCriteria";

const initialState: TranslationState = {
    refresh_list: false,
    translations_loading: false,
    translations: {},
    translation_rows: [],
    translation_rows_saving: [],
    value_lang: 'fr',
    target_lang: 'en',
    row_to_delte: null,
    search: '',
    translation_filters: EMPTY_TRANSLATION_FILTER
};

const setTranslationFiltersReducer = (state: TranslationState, action: PayloadAction<TranslationFilterCriteria>): TranslationState => ({
    ...state, translation_filters: action.payload
});

const refreshListReducer = (state: TranslationState): TranslationState => ({
    ...state, refresh_list: !state.refresh_list
});

const setTranslationsLoadingReducer = (state: TranslationState, action: PayloadAction<boolean>): TranslationState => ({
    ...state, translations_loading: action.payload
});

const setTranslationsReducer = (state: TranslationState, action: PayloadAction<Record<string, Translation>>): TranslationState => ({
    ...state, translations: action.payload
});

const setTranslationRowsReducer = (state: TranslationState, action: PayloadAction<TranslationRow[]>): TranslationState => ({
    ...state, translation_rows: action.payload
});

const setValueLangReducer = (state: TranslationState, action: PayloadAction<string>): TranslationState => ({
    ...state, value_lang: action.payload
});


const setTargetLangReducer = (state: TranslationState, action: PayloadAction<string>): TranslationState => ({
    ...state, target_lang: action.payload
});

const setTranslationRowsSavingReducer = (state: TranslationState, action: PayloadAction<{ id: string; value: boolean }[]>): TranslationState => ({
    ...state, translation_rows_saving: action.payload
});

const setOneTranslationRowsSavingReducer = (state: TranslationState, action: PayloadAction<{ id: string; value: boolean }>): TranslationState => ({
    ...state, translation_rows_saving: state.translation_rows_saving.map((row) => row.id === action.payload.id ? { ...row, value: action.payload.value } : row)
});

const setRowToDeleteReducer = (state: TranslationState, action: PayloadAction<TranslationRow | null>): TranslationState => ({
    ...state, row_to_delte: action.payload
});

const setSearchReducer = (state: TranslationState, action: PayloadAction<string>): TranslationState => ({
    ...state, search: action.payload
});

export const translation = createSlice({
    name: 'translation',
    initialState,
    reducers: {
        setTranslationFilters: setTranslationFiltersReducer,
        setTranslationsLoading: setTranslationsLoadingReducer,
        setTranslations: setTranslationsReducer,
        setTranslationRows: setTranslationRowsReducer,
        refreshList: refreshListReducer,
        setValueLang: setValueLangReducer,
        setTargetLang: setTargetLangReducer,
        setTranslationRowsSaving: setTranslationRowsSavingReducer,
        setOneTranslationRowsSaving: setOneTranslationRowsSavingReducer,
        setRowToDelete: setRowToDeleteReducer,
        setSearch: setSearchReducer
    }
});

export const { setTranslationFilters, refreshList, setTranslations, setTranslationsLoading, setTranslationRows, setValueLang, setTargetLang, setTranslationRowsSaving, setSearch, setOneTranslationRowsSaving, setRowToDelete } = translation.actions;